<template>
    <v-btn
        icon
        small
        elevation="0"
    >
        <v-icon
            @click="changeValue"
        >{{ localValue ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
    </v-btn>
</template>

<script>
export default {
    props: {
        value: Boolean,
        userId: Number,
        actionCreate: String,
        actionDelete: String
    },
    data() {
        return {
            localValue: this.value
        }
    },
    watch: {
        value(v) {
            this.localValue = v;
        },
        localValue(v) {
            this.$emit('input', v)
        }
    },
    methods: {
        changeValue() {
            let action = this.localValue ? this.actionDelete : this.actionCreate;

            this.$store.dispatch(action, {
                id: this.userId,
                data: {
                    follow_user_id: this.userId,
                }
            })
                .then(() => {
                    this.localValue = !this.localValue;
                });
        }
    }
}
</script>